<div class="not-found-wrapper" [ngClass]="{ mobile: (isMobile$ | async) === true }">
  <div class="not-found">
    <h1 class="mat-headline-2 mb-3" [ngClass]="{ 'mat-headline-3': (isMobile$ | async) === true }">{{ 'WM_TECH.NOT_FOUND.TITLE' | translate }}</h1>

    <svg *ngIf="app === 'wm-tech-mms'" width="349" height="434" viewBox="0 0 349 434" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path class="img-path" d="M175 83L175 0" stroke="#353535" stroke-miterlimit="10" stroke-linejoin="round" />
      <path
        d="M174.398 92.0003C179.698 92.0003 184.098 92.6003 184.398 93.4003C184.698 87.9003 180.498 83.1003 174.998 82.8003C169.498 82.5003 164.698 86.7003 164.398 92.2003C164.398 92.6003 164.398 93.0003 164.398 93.4003C164.698 92.7003 169.098 92.0003 174.398 92.0003Z"
        fill="url(#paint0_linear_7991_50666)"
      />
      <path
        d="M174.399 130.5C197.499 130.5 216.499 133.2 217.799 136.6V136.5C219.199 112.5 200.899 91.9001 176.899 90.5001C152.899 89.1001 132.299 107.4 130.899 131.4C130.799 133.2 130.799 135 130.899 136.7C132.399 133.2 151.299 130.5 174.399 130.5Z"
        fill="url(#paint1_linear_7991_50666)"
      />
      <path
        d="M174.398 143.5C198.423 143.5 217.898 140.59 217.898 137C217.898 133.41 198.423 130.5 174.398 130.5C150.374 130.5 130.898 133.41 130.898 137C130.898 140.59 150.374 143.5 174.398 143.5Z"
        fill="url(#paint2_linear_7991_50666)"
      />
      <g opacity="0.34" filter="url(#filter0_f_7991_50666)">
        <path d="M217.9 137C217.9 133.4 198.4 130.5 174.4 130.5C150.4 130.5 130.9 133.4 130.9 137L41 392.7H174.4H307.8L217.9 137Z" fill="url(#paint3_linear_7991_50666)" />
      </g>
      <defs>
        <filter id="filter0_f_7991_50666" x="0" y="89.5" width="348.8" height="344.2" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="20.5" result="effect1_foregroundBlur_7991_50666" />
        </filter>
        <linearGradient id="paint0_linear_7991_50666" x1="164.415" y1="88.064" x2="184.43" y2="88.064" gradientUnits="userSpaceOnUse">
          <stop stop-color="#070707" />
          <stop offset="1" stop-color="#57D374" />
        </linearGradient>
        <linearGradient id="paint1_linear_7991_50666" x1="130.895" y1="113.437" x2="217.947" y2="113.437" gradientUnits="userSpaceOnUse">
          <stop stop-color="#070707" />
          <stop offset="1" stop-color="#74FE74" />
        </linearGradient>
        <linearGradient id="paint2_linear_7991_50666" x1="130.969" y1="136.965" x2="217.971" y2="136.965" gradientUnits="userSpaceOnUse">
          <stop stop-color="#353535" />
          <stop offset="1" stop-color="#0F0F0F" />
        </linearGradient>
        <linearGradient id="paint3_linear_7991_50666" x1="174.422" y1="130.483" x2="174.422" y2="392.698" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FFFF00" />
          <stop offset="0.142" stop-color="#F4FF0B" stop-opacity="0.8167" />
          <stop offset="0.3469" stop-color="#ECFF13" stop-opacity="0.5523" />
          <stop offset="0.7747" stop-color="#EAFF15" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>

    <svg *ngIf="app === 'wm-tech-pool'" width="349" height="434" viewBox="0 0 349 434" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path class="img-path" d="M175 83L175 0" stroke="#353535" stroke-miterlimit="10" stroke-linejoin="round" />
      <path
        d="M174.398 92.0003C179.698 92.0003 184.098 92.6003 184.398 93.4003C184.698 87.9003 180.498 83.1003 174.998 82.8003C169.498 82.5003 164.698 86.7003 164.398 92.2003C164.398 92.6003 164.398 93.0003 164.398 93.4003C164.698 92.7003 169.098 92.0003 174.398 92.0003Z"
        fill="url(#paint0_linear_7991_50676)"
      />
      <path
        d="M174.399 130.5C197.499 130.5 216.499 133.2 217.799 136.6V136.5C219.199 112.5 200.899 91.9001 176.899 90.5001C152.899 89.1001 132.299 107.4 130.899 131.4C130.799 133.2 130.799 135 130.899 136.7C132.399 133.2 151.299 130.5 174.399 130.5Z"
        fill="url(#paint1_linear_7991_50676)"
      />
      <path
        d="M174.398 143.5C198.423 143.5 217.898 140.59 217.898 137C217.898 133.41 198.423 130.5 174.398 130.5C150.374 130.5 130.898 133.41 130.898 137C130.898 140.59 150.374 143.5 174.398 143.5Z"
        fill="url(#paint2_linear_7991_50676)"
      />
      <g opacity="0.34" filter="url(#filter0_f_7991_50676)">
        <path d="M217.9 137C217.9 133.4 198.4 130.5 174.4 130.5C150.4 130.5 130.9 133.4 130.9 137L41 392.7H174.4H307.8L217.9 137Z" fill="url(#paint3_linear_7991_50676)" />
      </g>
      <defs>
        <filter id="filter0_f_7991_50676" x="0" y="89.5" width="348.8" height="344.2" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="20.5" result="effect1_foregroundBlur_7991_50676" />
        </filter>
        <linearGradient id="paint0_linear_7991_50676" x1="164.415" y1="88.064" x2="184.43" y2="88.064" gradientUnits="userSpaceOnUse">
          <stop stop-color="#492B7C" />
          <stop offset="1" stop-color="#B990FF" />
        </linearGradient>
        <linearGradient id="paint1_linear_7991_50676" x1="130.895" y1="113.437" x2="217.947" y2="113.437" gradientUnits="userSpaceOnUse">
          <stop stop-color="#492B7C" />
          <stop offset="1" stop-color="#B990FF" />
        </linearGradient>
        <linearGradient id="paint2_linear_7991_50676" x1="130.969" y1="136.965" x2="217.971" y2="136.965" gradientUnits="userSpaceOnUse">
          <stop stop-color="#353535" />
          <stop offset="1" stop-color="#0F0F0F" />
        </linearGradient>
        <linearGradient id="paint3_linear_7991_50676" x1="174.422" y1="130.483" x2="174.422" y2="392.698" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FFFF00" />
          <stop offset="0.142" stop-color="#F4FF0B" stop-opacity="0.8167" />
          <stop offset="0.3469" stop-color="#ECFF13" stop-opacity="0.5523" />
          <stop offset="0.7747" stop-color="#EAFF15" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>

    <svg *ngIf="app === 'wm-tech'" width="349" height="434" viewBox="0 0 349 434" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path class="img-path" d="M175 83L175 0" stroke="#353535" stroke-miterlimit="10" stroke-linejoin="round" />
      <path
        d="M174.398 92.0003C179.698 92.0003 184.098 92.6003 184.398 93.4003C184.698 87.9003 180.498 83.1003 174.998 82.8003C169.498 82.5003 164.698 86.7003 164.398 92.2003C164.398 92.6003 164.398 93.0003 164.398 93.4003C164.698 92.7003 169.098 92.0003 174.398 92.0003Z"
        fill="url(#paint0_linear_7991_50712)"
      />
      <path
        d="M174.399 130.5C197.499 130.5 216.499 133.2 217.799 136.6V136.5C219.199 112.5 200.899 91.9001 176.899 90.5001C152.899 89.1001 132.299 107.4 130.899 131.4C130.799 133.2 130.799 135 130.899 136.7C132.399 133.2 151.299 130.5 174.399 130.5Z"
        fill="url(#paint1_linear_7991_50712)"
      />
      <path
        d="M174.398 143.5C198.423 143.5 217.898 140.59 217.898 137C217.898 133.41 198.423 130.5 174.398 130.5C150.374 130.5 130.898 133.41 130.898 137C130.898 140.59 150.374 143.5 174.398 143.5Z"
        fill="url(#paint2_linear_7991_50712)"
      />
      <g opacity="0.34" filter="url(#filter0_f_7991_50712)">
        <path d="M217.9 137C217.9 133.4 198.4 130.5 174.4 130.5C150.4 130.5 130.9 133.4 130.9 137L41 392.7H174.4H307.8L217.9 137Z" fill="url(#paint3_linear_7991_50712)" />
      </g>
      <defs>
        <filter id="filter0_f_7991_50712" x="0" y="89.5" width="348.8" height="344.2" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="20.5" result="effect1_foregroundBlur_7991_50712" />
        </filter>
        <linearGradient id="paint0_linear_7991_50712" x1="164.415" y1="88.064" x2="184.43" y2="88.064" gradientUnits="userSpaceOnUse">
          <stop stop-color="#353535" />
          <stop offset="1" stop-color="#F2F2F2" />
        </linearGradient>
        <linearGradient id="paint1_linear_7991_50712" x1="130.895" y1="113.437" x2="217.947" y2="113.437" gradientUnits="userSpaceOnUse">
          <stop stop-color="#353535" />
          <stop offset="1" stop-color="#F2F2F2" />
        </linearGradient>
        <linearGradient id="paint2_linear_7991_50712" x1="130.969" y1="136.965" x2="217.971" y2="136.965" gradientUnits="userSpaceOnUse">
          <stop stop-color="#353535" />
          <stop offset="1" stop-color="#0F0F0F" />
        </linearGradient>
        <linearGradient id="paint3_linear_7991_50712" x1="174.422" y1="130.483" x2="174.422" y2="392.698" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FFFF00" />
          <stop offset="0.142" stop-color="#F4FF0B" stop-opacity="0.8167" />
          <stop offset="0.3469" stop-color="#ECFF13" stop-opacity="0.5523" />
          <stop offset="0.7747" stop-color="#EAFF15" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>

    <p>
      <span>{{ 'WM_TECH.NOT_FOUND_DESCRIPTION' | translate }}</span>
      <a [class]="app + '-class' + ' bold'" [href]="app === 'wm-tech-pool' ? env.techPoolDomain : app === 'wm-tech-mms' ? env.techMmsDomain : env.techDomain">
        {{ 'WM_TECH.NOT_FOUND_DESCRIPTION.' + app | uppercase | translate }}
      </a>
    </p>
  </div>
</div>
